import { tMap } from '@app/i18n';
import NotFoundPage from '@app/pages/not-found';
import { FC, useEffect } from 'react';
import { formatDate } from '@app/utils';
import { CookiePopup, Footer, Header, NoInternetPopup } from '@app/components/index';
import { useOrdersControllerReceivedMutation } from '@app/api/ordersApi/orders-api';
import { useParams } from 'react-router-dom';

import './gift.page.scss';
import { useGiftQuery } from './gift-query.hook';
import GiftCard from './components/giftCard/GiftCard';

const GiftPage: FC = () => {
  const { token } = useParams();
  const { data: gift, isError, isSuccess } = useGiftQuery(token ?? '');

  const [markAsReceived] = useOrdersControllerReceivedMutation();

  useEffect(() => {
    if (token) {
      markAsReceived({ token });
    }
  }, [token, markAsReceived]);

  if (!token) {
    return <NotFoundPage />;
  }

  if (isError || (isSuccess && !gift)) {
    return <NotFoundPage />;
  }

  return (
    <div className="app">
      <Header />
      <main className="gift-page">
        <div className="gift-page__card-wrapper">
          <GiftCard
            key={gift?.cardNumber}
            date={formatDate(new Date(gift?.expireDate as string))}
            image={`${process.env.REACT_APP_IMAGES_URL}/${gift?.product?.imageUrl}`}
            nominal={gift?.nominal ?? 0}
            remains={gift?.nominal ?? 0}
            giftMessage={gift?.giftMessage}
            cardNumber={gift?.cardNumber ?? ''}
            title={tMap(gift?.product?.name)}
          />
        </div>
      </main>
      <Footer />
      <CookiePopup />
      <NoInternetPopup />
    </div>
  );
};

export default GiftPage;
